// extracted by mini-css-extract-plugin
export default {"signup":"SIgnup_signup__tGun5","form":"SIgnup_form__XBnx5","input":"SIgnup_input__rBxmy","actions":"SIgnup_actions__ksMyx","info":"SIgnup_info__2N2Gq"};